export default __webpack_public_path__ + "static/media/dr-candice.5cb49e11.jpg";